// dépendances
require("./bootstrap");

// script commun à toute l'app
require("./common");


// WEBPACK FOOTER //
// ./resources/assets/js/app.js